import AdminDashboard from './AdminDashboard.page';

export default AdminDashboard;